import React from 'react';
import '../styles/ColorSelector.css';

// 改造后的组件接收 value 和 onChange 属性
const ColorSelector = ({ value, onChange, colors = [] }) => {
    // const colors = [
    //     '灰色', '绿色', '黄色', '橙色', '深红',
    //     '紫色', '深棕', '浅棕', '冷棕', '暖棕',
    //     '蓝色', '蓝色', '褪色'
    // ];

    const selectedLabel = typeof value === 'object' && value !== null ? value.label : value;
    const safeColors = Array.isArray(colors) ? colors.filter(color => color && color.label) : [];

    return (
        <div className="color-selector">
            {safeColors.map((color, index) => (
                <div
                    key={`${color.label}-${index}`}
                    className={`color-option ${selectedLabel === color.label ? 'selected' : ''}`}
                    style={{
                        backgroundColor: selectedLabel === color.label ? '#2f7aeb' : '',
                        // 可以添加其他样式
                    }}
                    onClick={() => onChange?.(color.label)}
                    title={color.label}
                >
                    <span className="color-text">{color.label}</span>
                </div>
            ))}
        </div>
    );
};

// 辅助函数，将颜色名称转换为实际颜色代码
function getColorCode(colorName) {
    const colorMap = {
        '灰色': '#808080',
        '绿色': '#008000',
        '黄色': '#FFFF00',
        '橙色': '#FFA500',
        '深红': '#8B0000',
        '紫色': '#800080',
        '深棕': '#654321',
        '浅棕': '#D2B48C',
        '冷棕': '#8B7D6B',
        '暖棕': '#964B00',
        '蓝色': '#0000FF',
        '褪色': '#F5F5F5'
    };

    return colorMap[colorName] || '#FFFFFF';
}

export default ColorSelector;
